<template>
  <div>
    <div class="container-msg">
      <div class="mainContent-msg">
        <!-- <div class="head-msg">
          <div class="head-content">
            <img src="./发件邮箱配置说明_files/logo1.png">
            <h1>发件邮箱配置说明</h1>
          </div>
        </div>
        <p class="msg-time">20200120</p> -->
        <div class="main-body" id="article-content">
          <blockquote>
            <p>发件邮箱用于发出系统的通知邮件，可根据贵公司的需要，设置发件邮箱地址、发件人名称。如果此发件邮箱没有配置，或者配置后密码等信息更改导致连接失败，将会采用系统默认的发件邮箱。</p>
          </blockquote>

          <p>在配置前，需要先确认邮箱的SMTP协议是否开启，开启后才可继续在系统中设置。设置发件邮箱的步骤只需3步：</p>

          <blockquote>
            <h2 id="1">第1步，填写邮箱与密码</h2>
          </blockquote>

          <p>1.邮箱地址，注意完整的填写邮件地址，如：support@sogukj.com;</p>

          <p>2.邮箱密码，注意字母的大小写。对于QQ邮箱等特殊的邮箱，在开启SMTP协议时，会得到授权码，需要将授权码当作密码使用。（填写所有信息后，保存时会校验密码是否正确，配置是否正确）</p>

          <!-- <p><img src="./发件邮箱配置说明_files/1579507376539.png" alt=""></p> -->

          <blockquote>
            <h2 id="2">第2步，填写服务器地址与端口号</h2>
          </blockquote>

          <p>1.不同的邮箱类型，对应的发件服务器地址不同，一般的格式都是smtp开头，比如163的发件服务器地址：smtp.163.com。常见邮箱的发件服务器地址（SMTP）都可以百度搜索到，端口号一般是465；</p>

          <p>2.如果贵公司是自建邮件服务器，请联系贵公司管理员，确认发件服务器地址、端口号。</p>

          <!-- <p><img src="./发件邮箱配置说明_files/1579507494347.png" alt=""></p> -->

          <p>附：</p>

          <p>QQ邮箱需要开启SMTP协议，且将得到的授权码作为密码使用，详细操作请点击<a
              href="https://service.mail.qq.com/cgi-bin/help?subtype=1&amp;&amp;id=28&amp;&amp;no=1001256">QQ邮箱SMTP协议配置</a>
          </p>

          <p>常见邮箱发件服务器地址及端口号见下表</p>

          <table border="1" style="border-collapse:collapse;margin:auto">
            <tbody>
              <tr>
                <th>邮箱类型</th>
                <th>SMTP服务器地址</th>
                <th>端口号</th>
              </tr>
              <tr>
                <td>QQ邮箱</td>
                <td>smtp.qq.com</td>
                <td>465</td>
              </tr>
              <tr>
                <td>腾讯企业邮箱</td>
                <td>smtp.exmail.qq.com</td>
                <td>465</td>
              </tr>
              <tr>
                <td>腾讯企业邮箱(海外)</td>
                <td>hwsmtp.exmail.qq.com</td>
                <td>465</td>
              </tr>
              <tr>
                <td>阿里云邮箱个人版</td>
                <td>smtp.aliyun.com</td>
                <td>465</td>
              </tr>
              <tr>
                <td>阿里云邮箱企业版</td>
                <td>smtp.qiye.aliyun.com</td>
                <td>465</td>
              </tr>
              <tr>
                <td>网易163个人邮箱</td>
                <td>smtp.163.com</td>
                <td>465</td>
              </tr>
              <tr>
                <td>网易163付费企业邮箱</td>
                <td>smtp.qiye.163.com</td>
                <td>994</td>
              </tr>
              <tr>
                <td>网易163免费企业邮箱</td>
                <td>smtp.ym.163.com</td>
                <td>994</td>
              </tr>
              <tr>
                <td>网易163海外版邮箱</td>
                <td>hwhzsmtp.qiye.163.com</td>
                <td>994</td>
              </tr>
              <tr>
                <td>网易126邮箱</td>
                <td>smtp.126.com </td>
                <td>465</td>
              </tr>
              <tr>
                <td>网易yeah邮箱</td>
                <td>smtp.yeah.net</td>
                <td>465</td>
              </tr>
              <tr>
                <td>网易netease邮箱</td>
                <td>smtp.netease.com</td>
                <td>465</td>
              </tr>
              <tr>
                <td>新浪com邮箱</td>
                <td>smtp.sina.com</td>
                <td>465</td>
              </tr>
              <tr>
                <td>新浪cn邮箱</td>
                <td>smtp.sina.cn</td>
                <td>465</td>
              </tr>
              <tr>
                <td>新浪vip邮箱</td>
                <td>smtp.vip.sina.com</td>
                <td>465</td>
              </tr>
              <tr>
                <td>搜狐邮箱</td>
                <td>smtp.sohu.com</td>
                <td>465</td>
              </tr>
              <tr>
                <td>谷歌邮箱Gmail</td>
                <td>smtp.gmail.com</td>
                <td>465</td>
              </tr>
              <tr>
                <td>雅虎邮箱Yahoo</td>
                <td>smtp.mail.yahoo.com</td>
                <td>465</td>
              </tr>
              <tr>
                <td>Office 365</td>
                <td>smtp.partner.outlook.cn或smtp.office365.com</td>
                <td>587</td>
              </tr>
              <tr>
                <td>139邮箱</td>
                <td>smtp.139.com</td>
                <td>465</td>
              </tr>
              <tr>
                <td>263企业邮箱</td>
                <td>smtp.263.net</td>
                <td>465</td>
              </tr>
              <tr>
                <td>263企业邮箱(海外）</td>
                <td>smtpw.263.net</td>
                <td>465</td>
              </tr>
              <tr>
                <td>outlook企业邮箱</td>
                <td>smtp-mail.outlook.com</td>
                <td>587</td>
              </tr>

            </tbody>
          </table>

          <blockquote>
            <h2 id="3">第3步，填写发件人名称</h2>
          </blockquote>

          <p>发件人名称，就是收件方在邮件中看到的发件人名称。一般都是填写公司/集团简称，或者品牌名称。</p>

          <p>注：填写完信息，正常情况下，点击“确定”后，提示“保存成功”</p>

          <!-- <p><img src="./发件邮箱配置说明_files/1579507851725.png" alt=""></p> -->

          <blockquote>
            <p>如有疑问，请联系易招聘客服同学~</p>
          </blockquote>
        </div>
        <!-- <span class="company"><span>2020&nbsp;©&nbsp;企家有道网络技术（北京）有限公司&nbsp;&nbsp;&nbsp;联系我们：400-666-1290</span></p> -->
      </div>
    </div>
    <div id="extensionXrxs" data-version="2.1.1" data-extensionid="cegcpiejpkjgniflhpaefbgpnhdlklml"></div>
  </div>
</template>
<script>
  export default {
    data() {
      return {}
    },
    mounted: function () {
      this.$store.dispatch("first_nav_change", "110");
    },
  }

</script>



// WEBPACK FOOTER //
// src/components/pages/sendEmail.vue